
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"30","viewBox":"0 0 33 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.7961 14.5233L17.1805 19.3141L13.3732 13.6641L11.2858 17.1706H4.03711C7.57776 20.8969 15.1807 28.6063 15.571 29.0019L16.2241 29.6641L16.8772 29.002C17.3529 28.5198 28.544 17.1718 30.0339 15.4148C30.275 15.1305 30.4983 14.8326 30.7038 14.5233H20.7961Z","fill":"white"}}),_c('path',{attrs:{"d":"M23.0613 0.332031C20.3045 0.332031 17.7249 1.64096 16.0371 3.82567C14.3493 1.64096 11.7697 0.332031 9.01292 0.332031C4.06361 0.332031 0.0371094 4.48406 0.0371094 9.58753C0.0371094 11.7702 0.780359 13.8692 2.1353 15.534H10.1035L13.1121 10.6175L17.0705 16.332L19.672 12.979H31.4135C31.8222 11.9088 32.0371 10.7603 32.0371 9.58753C32.0371 4.48406 28.0106 0.332031 23.0613 0.332031Z","fill":"white"}})])
          )
        }
      }
    